// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { selectBoardPermissionToastPermissions } from './boardPermissionToastSelector';
import { isFeedbackOnlyAccess, isReadOnly } from '../../../../common/permissions/permissionUtil';

// Components
import Toast from '../../../structural/toast/Toast';
import Icon from '../../../components/icons/Icon';

const UserBoardPermissionToast: React.FC = () => {
    const permissions = useSelector(selectBoardPermissionToastPermissions);

    if (isFeedbackOnlyAccess(permissions)) {
        return (
            <Toast className="BoardPermissionToast UserBoardPermissionToast feedback">
                <Icon name="board-status-feedback" />
                <span>Comment only</span>
            </Toast>
        );
    }

    if (isReadOnly(permissions)) {
        return (
            <Toast className="BoardPermissionToast UserBoardPermissionToast">
                <Icon name="board-status-read-only" />
                <span>Read only</span>
            </Toast>
        );
    }

    return null;
};

export default UserBoardPermissionToast;
